module.exports = __webpack_public_path__ + "static/media/external-link-alt.96c6bcf6.svg";